export class LoadCoreData {
    static readonly type = '[Pages] Load core data';
}
